/* istanbul ignore file */
// * This file opens URL and bases on Linking implementation

import Clipboard from "@react-native-clipboard/clipboard";
import { Linking } from "react-native";

const openUrl = (url: string) => Linking.openURL(url);

export const sendEmail = (email: string, subject?: string) =>
  openUrl(`mailTo:${email}${subject ? `?subject=${subject}` : ""}`);

export const callNumber = (number?: string) => {
  Clipboard.setString(number || "");
  openUrl(`tel:${number}`);
};
